import React from 'react';
import { PropTypes } from 'prop-types';

import { LoadingContainer } from '@styled';

const getText = (activeOnly, text) => {
    if (text) return text;
    return activeOnly
        ? 'You must be logged in and have an active membership to view this content'
        : 'You must be logged in to view this content';
};

const Unauthorized = ({ children, activeOnly = false, text }) => {
    const message = getText(activeOnly, text);

    return (
        <LoadingContainer minHeight={250} minHeightMobile={200}>
            <div className="px-4" style={{ maxWidth: '550px' }}>
                <h3>{message}</h3>
                {children}
            </div>
        </LoadingContainer>
    );
};

Unauthorized.propTypes = {
    children: PropTypes.any,
    activeOnly: PropTypes.bool,
    text: PropTypes.string,
};

export default Unauthorized;
